import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const PlaceholderPage = ({ title, subtitle }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow flex items-center justify-center bg-gray-50 pt-24">
        <div className="text-center px-6">
          <h1 className="text-5xl font-bold text-[#29367A] mb-4">{title}</h1>
          <p className="text-xl text-gray-600">{subtitle}</p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

// Savi Sub-pages
export const SaviWhatPage = () => (
  <PlaceholderPage
    title="The What"
    subtitle="Discover what Savi Investing is all about"
  />
);

export const SaviWhyPage = () => (
  <PlaceholderPage
    title="The Why"
    subtitle="Understand why value investing matters"
  />
);

export const SaviHowPage = () => (
  <PlaceholderPage
    title="The How"
    subtitle="Learn how we approach disciplined investing"
  />
);

// Other Pages
export const PortfolioPage = () => (
  <PlaceholderPage
    title="Inside Our Portfolio"
    subtitle="Explore our concentrated mix of select Indian equities"
  />
);

export const FrameworkPage = () => (
  <PlaceholderPage
    title="Our Investing Framework"
    subtitle="The principles that guide our investment decisions"
  />
);

export const DisclaimerPage = () => (
  <PlaceholderPage
    title="Disclaimer"
    subtitle="Important information and disclosures"
  />
);

export const ReachUsPage = () => (
  <PlaceholderPage
    title="Reach Us"
    subtitle="Get in touch with our team"
  />
);
